import { render } from "./Footer.vue?vue&type=template&id=5d43de4b"
const script = {}
script.render = render

export default script